import React from 'react';
import PropTypes from 'prop-types';
import { Icon, LinkText } from '../../index';

export const IconButton = ({
    ariaDescribedBy,
    ariaLabel,
    disabled,
    icon,
    id,
    size,
    to,
    onClick,
}) => {

    return (
        <LinkText
            as={to ? undefined : <button type="button"></button>}
            aria-describedby={ariaDescribedBy}
            className="icon-button"
            disabled={disabled}
            id={id}
            onClick={onClick}
            to={to}
            underline="none"
        >
            <Icon name={icon} size={size} ariaLabel={ariaLabel} />
        </LinkText>
    );
};

IconButton.propTypes = {
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    id: PropTypes.string,
    size: PropTypes.string,
    onClick: PropTypes.func,
}